// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import "../styles/pageRows.css"; */

.regular-row {
	display: flex;
	flex-direction: column;
	align-items: center;
	/* margin: 0.5rem 0.5rem; */
}

.reverse {
	flex-direction: column-reverse;
}

.regular-row.content p {
	font-size: 1.4rem;
	text-align: justify;
	text-align-last: left;
	padding: 0rem;
	margin-bottom: 2rem;
	line-height: 2rem;
}
.regular-row.content p.single-line {
	text-align: left;
	align-self: flex-start;
}
.regular-row.content p.citation {
	font-size: 1.2rem;
	font-style: italic;
	margin-top: -2rem;
	margin-bottom: 2rem;
}	

.regular-row.content h5 {
	font-size: 2.4rem;
	padding: 1rem 0rem;
	line-height: 2.8rem;
	text-align: center;
}
.regular-row.content h4 {
	font-size: 3rem;
	padding: 1rem 0rem;
	line-height: 3.2rem;
	text-align: center;
}
.regular-row.content h6 {
	font-size: 1.8rem;
	padding: 1rem 0rem;
	line-height: 3.2rem;
	text-align: center;
}
.regular-row.content ul {
	font-size: 1.4rem;
	text-align: left;
	align-self: flex-start;
	padding: 0rem;
	margin-bottom: 2rem;
	line-height: 2rem;
	list-style-position: inside;
}

@media (min-width: 500px) {
	.regular-row {
		margin: 1rem 1rem;
	}
	.regular-row.content p {
		font-size: 1.62vw;
		text-align: justify;
		text-align-last: left;
		padding: 0rem;
		margin-bottom: 2vw;
		line-height: 2.5vw;
	}
	.regular-row.content p.citation {
		font-size: 1.2vw;
		margin-top: -3vw;
	}	
	.regular-row.content h4 {
		font-size: 3vw;
		padding: 1rem 0rem;
		line-height: 3.2vw;
		text-align: center;
	}
	.regular-row.content h5 {
		font-size: 2.4vw;
		margin-bottom: 2vw;
		line-height: 2.6vw;
		text-align: center;
	}

	.regular-row.content h6 {
		font-size: 1.8vw;
		line-height: 2.6vw;
		margin-bottom: 2rem;
		text-align: center;
	}
	.regular-row.content ul {
		font-size: 1.62vw;
	}
}

@media (min-width: 1000px) {
	.regular-row.content p {
		font-size: 1.6rem;
		text-align: justify;
		text-align-last: left;
		padding: 0rem;
		margin-bottom: 2rem;
		line-height: 2.5rem;
	}
	.regular-row.content p.citation {
		font-size: 1.2rem;
		margin-top: -2rem;
	}	
	.regular-row.content strong {
		font-family: "Inter-Bold", sans-serif;
		font-weight: bold;
	}
	.regular-row.content h6 {
		font-size: 1.8rem;
		padding: 0rem;
		/* margin: 0rem 1rem; */
		line-height: 2.6rem;
		text-align: center;
	}
	.regular-row.content h5 {
		font-size: 2.4rem;
		padding: 1rem 0rem;
		line-height: 2.8rem;
	}

	.regular-row.content h4 {
		font-size: 3rem;
		padding: 1rem 0rem;
		line-height: 3.2rem;
	}
	.regular-row.content ul {
		font-size: 1.6rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/pages/GenericPage/PageRows/RegularRow/regularRow.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;CACnB,qBAAqB;CACrB,aAAa;CACb,mBAAmB;CACnB,iBAAiB;AAClB;AACA;CACC,gBAAgB;CAChB,sBAAsB;AACvB;AACA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,sBAAsB;CACtB,aAAa;CACb,mBAAmB;CACnB,iBAAiB;CACjB,2BAA2B;AAC5B;;AAEA;CACC;EACC,iBAAiB;CAClB;CACA;EACC,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;CACnB;CACA;EACC,gBAAgB;EAChB,gBAAgB;CACjB;CACA;EACC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;CACnB;CACA;EACC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;CACnB;CACA;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;CACpB;CACA;EACC,iBAAiB;EACjB,iBAAiB;CAClB;CACA;EACC,qCAAqC;EACrC,iBAAiB;CAClB;CACA;EACC,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;CACnB;CACA;EACC,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,eAAe;EACf,kBAAkB;EAClB,mBAAmB;CACpB;CACA;EACC,iBAAiB;CAClB;AACD","sourcesContent":["/* @import \"../styles/pageRows.css\"; */\n\n.regular-row {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\t/* margin: 0.5rem 0.5rem; */\n}\n\n.reverse {\n\tflex-direction: column-reverse;\n}\n\n.regular-row.content p {\n\tfont-size: 1.4rem;\n\ttext-align: justify;\n\ttext-align-last: left;\n\tpadding: 0rem;\n\tmargin-bottom: 2rem;\n\tline-height: 2rem;\n}\n.regular-row.content p.single-line {\n\ttext-align: left;\n\talign-self: flex-start;\n}\n.regular-row.content p.citation {\n\tfont-size: 1.2rem;\n\tfont-style: italic;\n\tmargin-top: -2rem;\n\tmargin-bottom: 2rem;\n}\t\n\n.regular-row.content h5 {\n\tfont-size: 2.4rem;\n\tpadding: 1rem 0rem;\n\tline-height: 2.8rem;\n\ttext-align: center;\n}\n.regular-row.content h4 {\n\tfont-size: 3rem;\n\tpadding: 1rem 0rem;\n\tline-height: 3.2rem;\n\ttext-align: center;\n}\n.regular-row.content h6 {\n\tfont-size: 1.8rem;\n\tpadding: 1rem 0rem;\n\tline-height: 3.2rem;\n\ttext-align: center;\n}\n.regular-row.content ul {\n\tfont-size: 1.4rem;\n\ttext-align: left;\n\talign-self: flex-start;\n\tpadding: 0rem;\n\tmargin-bottom: 2rem;\n\tline-height: 2rem;\n\tlist-style-position: inside;\n}\n\n@media (min-width: 500px) {\n\t.regular-row {\n\t\tmargin: 1rem 1rem;\n\t}\n\t.regular-row.content p {\n\t\tfont-size: 1.62vw;\n\t\ttext-align: justify;\n\t\ttext-align-last: left;\n\t\tpadding: 0rem;\n\t\tmargin-bottom: 2vw;\n\t\tline-height: 2.5vw;\n\t}\n\t.regular-row.content p.citation {\n\t\tfont-size: 1.2vw;\n\t\tmargin-top: -3vw;\n\t}\t\n\t.regular-row.content h4 {\n\t\tfont-size: 3vw;\n\t\tpadding: 1rem 0rem;\n\t\tline-height: 3.2vw;\n\t\ttext-align: center;\n\t}\n\t.regular-row.content h5 {\n\t\tfont-size: 2.4vw;\n\t\tmargin-bottom: 2vw;\n\t\tline-height: 2.6vw;\n\t\ttext-align: center;\n\t}\n\n\t.regular-row.content h6 {\n\t\tfont-size: 1.8vw;\n\t\tline-height: 2.6vw;\n\t\tmargin-bottom: 2rem;\n\t\ttext-align: center;\n\t}\n\t.regular-row.content ul {\n\t\tfont-size: 1.62vw;\n\t}\n}\n\n@media (min-width: 1000px) {\n\t.regular-row.content p {\n\t\tfont-size: 1.6rem;\n\t\ttext-align: justify;\n\t\ttext-align-last: left;\n\t\tpadding: 0rem;\n\t\tmargin-bottom: 2rem;\n\t\tline-height: 2.5rem;\n\t}\n\t.regular-row.content p.citation {\n\t\tfont-size: 1.2rem;\n\t\tmargin-top: -2rem;\n\t}\t\n\t.regular-row.content strong {\n\t\tfont-family: \"Inter-Bold\", sans-serif;\n\t\tfont-weight: bold;\n\t}\n\t.regular-row.content h6 {\n\t\tfont-size: 1.8rem;\n\t\tpadding: 0rem;\n\t\t/* margin: 0rem 1rem; */\n\t\tline-height: 2.6rem;\n\t\ttext-align: center;\n\t}\n\t.regular-row.content h5 {\n\t\tfont-size: 2.4rem;\n\t\tpadding: 1rem 0rem;\n\t\tline-height: 2.8rem;\n\t}\n\n\t.regular-row.content h4 {\n\t\tfont-size: 3rem;\n\t\tpadding: 1rem 0rem;\n\t\tline-height: 3.2rem;\n\t}\n\t.regular-row.content ul {\n\t\tfont-size: 1.6rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
